export default __webpack_public_path__ + "static/media/carol.d8dbafe6.jpg";